import React from "react";

function Mode() {
  return (
    <>
      <div className="md:row-span-2 bg-sky-200 rounded-2xl drop-shadow-lg">
        <div>
          <p className="text-left m-4 md:text-2xl lg:text-3xl">
            <span className="font-bold text-black">Ah!</span> Good to see you
            here. This page is a quick of summary of what I’ve been upto. It’s
            pretty simple so if you wish to go into details, check out my{" "}
            <a href="/" className="font-bold text-black no-underline">
              Youtube Channel
            </a>{" "}
            and{" "}
            <a href="/" className="font-bold text-black no-underline">
              About Me
            </a>
            .
          </p>
        </div>
      </div>
      
    </>
  );
}

export default Mode;
